module.exports = __webpack_public_path__ + "img/slideshow.ee013517.png";